import * as React from 'react';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  TextField,
  CardContent,
  Alert,
  MenuItem,
  TableHead,
  IconButton,
  Collapse,
  Divider,
  Rating,
  List
  // Snackbar
} from '@mui/material';
import Label from 'src/components/Label';
import { LoadingButton } from '@mui/lab';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { ChangeRoleModal, ResetUserPassword, UserListHead } from '../sections/@dashboard/user';

import pallete from '../theme/palette';
import { api } from '../Api';
import { useTranslation } from 'react-i18next';
import EditUserModal from 'src/sections/@dashboard/user/EditUserModal';
import AddAdminModal from 'src/sections/@dashboard/user/AddAdminModal';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import dayjs from 'dayjs';
import UserDetailPaymentAdmin from 'src/sections/@dashboard/user/UserDetailPaymentAdmin';
import CompanyProfile from 'src/sections/@dashboard/user/CompanyProfileModal';
import UserCompanyProfileModal from 'src/sections/@dashboard/user/UserCompanyProfileModal';

export default function User() {
  const { t } = useTranslation();
  const TABLE_HEAD = [
    { id: 'name', label: t('Users.table.0'), alignRight: false },
    { id: 'email', label: t('Users.table.1'), alignRight: false },
    { id: 'contact', label: t('Users.table.2'), alignRight: false },
    { id: 'status', label: t('Users.table.4'), alignRight: false },
    { id: 'action', label: t('Users.table.5'), alignRight: false }
  ];
  const [permission, setpermission] = useState([]);
  const requirement = [
    'visible',
    'add',
    'edit',
    'edit role',
    'change status',
    'change password',
    'change role'
  ];

  function checkRender() {
    let check = 'users';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );

    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [search, setsearch] = useState('');
  const [status, setstatus] = useState(null);
  const [loading, setloading] = useState(true);
  const [searchLoading, setsearchLoading] = useState(false);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  const [statusss, setStatus] = useState(null);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [selectedStatus, setSelectedStatus] = useState('');
  const [alertSuccess, setalertSuccess] = useState({ visible: false, message: '' });
  const [productDetailsOpen, setProductDetailsOpen] = useState(false);
  const [ratingmodal, setratingmodal] = useState(false);
  const [statusfilter, setStatusFilter] = useState(null);
  const [roles, setRoles] = useState([]);
  const [reasondrop, setReasondrop] = useState(null);
  const [userdetail, setuserdetail] = useState('');
  const [userpaymentmodal, setUserPaymentModal] = useState(false);
  const [statusLoading, setstatusLoading] = useState(false);

  const [sortinglist, setsortinglist] = useState([
    { id: 1, code: 'date_newest_first', name: 'Date:  New to Old' },
    { id: 2, code: 'date_oldest_first', name: 'Date:  Old to New ' },
    { id: 5, code: 'a_to_z', name: 'Name:  A to Z' },
    { id: 6, code: 'z_to_a', name: 'Name:  Z to A' }
  ]);
  const handlePageChange = (event, value) => {
    list.length = 0;
    setPage(value);
    getUsers(value, statusfilter, reasondrop);
  };

  function getUsers(page, filter, sorting) {
    setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    // Construct the query string
    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    filter && filter?.name != 'All' && queryParams.append('status', filter.id);
    sorting !== 'undefined' &&
      sorting &&
      sorting?.name != 'All' &&
      queryParams.append('orderBy', sorting.code);
    // queryParams.append('admin', true);

    // const formdata = new FormData();
    // search.length > 0 && formdata.append('search', search);
    // filter && filter?.name != 'All' && formdata.append(status, filter.name);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
      // body: formdata
    };
    // fetch(api.getUsers, requestOptions)
    fetch(`${api.getUsers}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setlist(result.data);
          console.log('=======pagination user', result);

          result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
        } else {
          setlist([]);
          setpagesCount(0);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  function getUserStatus() {
    // setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('type', 'user');
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.get_user_status}?${params.toString()}`, requestOptions)
      // fetch(api.get_user_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          let totalData = [{ id: 10, name: 'All', value: 'All' }, ...result?.data];
          setStatusList(totalData);
          setStatusFilter(totalData.find((item) => item.id === 10));
        } else {
          setStatusList([]);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
      });
  }

  useEffect(() => {
    if (reasondrop == '') {
      setReasondrop(sortinglist[0]);
    }
  }, []);

  useEffect(() => {
    const getRoles = async () => {
      const myHeaders = new Headers();
      const token = localStorage.getItem('token');
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      try {
        const response = await fetch(api.getRoleNames, requestOptions);
        const result = await response.json();
        if (result.success) {
          let roleData = [{ id: 10, role_name: 'All' }, ...result?.data];
          setRoles(roleData);
          setReasondrop(roleData.find((item) => item?.id == 10));
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };
    getRoles();
  }, []);

  const handleOpenStatus = () => {
    setOpenStatus(true);
  };

  const handleCloseStatus = () => {
    setOpenStatus(false);
    setStatus(null);
    setalert({ visible: false, message: '' });
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getUsers(1, statusfilter, reasondrop);
    getUserStatus();
  }, []);

  const [open, setOpen] = React.useState(false);
  const [openStatus, setOpenStatus] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [openReset, setOpenReset] = React.useState(false);
  const [user, setuser] = useState(null);
  const [AddAdminmodal, setAddAdminModal] = useState(false);
  const [reviewratinglist, setreviewratinglist] = useState('');
  const [companymodal, setcompanymodal] = useState(false);
  const [companyprofiledata, setcompanyprofiledata] = useState(null);
  const [companyusermodal, setcompanyusermodal] = useState(false);
  // useEffect(() => {
  //   if (user) {
  //     const selected = statusList?.filter((e) => {
  //       console.log('e========>>>>', e, user?.status);

  //       e.value.toLowerCase() === user?.status.toLowerCase();
  //     });
  //     setSelectedStatus(selected[0]);
  //   }
  // }, [user]);

  useEffect(() => {
    if (user && statusList?.length) {
      const selected = statusList.filter(
        (e) => e.value.toLowerCase() === user?.status.toLowerCase()
      );
      setSelectedStatus(selected[0] || null);
    }
  }, [user, statusList]);

  function openModal(user) {
    setuser(user);
    handleOpen();
  }

  function openModalStatus(user) {
    setuser(user);
    handleOpenStatus();
  }

  function openResetModal(user) {
    setuser(user);
    setOpenReset(true);
  }

  function openUserModal(user) {
    setuser(user);
    setOpenUser(true);
  }

  function openAdminModal() {
    // setuser(user);
    setAddAdminModal(true);
  }

  function OpenCompanyModal(row) {
    setcompanyprofiledata(row);
    setcompanymodal(true);
  }
  const handleCloseCompanyModal = () => {
    setcompanymodal(false);
  };

  function OpenCompanyUserModal() {
    setcompanyusermodal(true);
  }
  const handleCloseCompanyUserModal = () => {
    setcompanyusermodal(false);
  };

  const handleCloseUserModal = () => setOpenUser(false);
  const handleCloseModal = () => setOpenReset(false);
  const handleAddAdminCloseModal = () => setAddAdminModal(false);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isUserNotFound = list.length === 0;

  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const boxStyle = {
    maxWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };
  const HistoryboxStyle = {
    minWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };

  const refreshAdmin = () => {
    setloading(true);
    setlist([]);
    setOpen(false);
    setOpenUser(false);
    getUsers(page, statusfilter, reasondrop);
  };

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getUsers(page);
    }
  }, [search]);

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  console.log('=======', statusss);
  const handlefilterstatus = (event) => {
    setStatusFilter(event.target.value);
    list.length = 0;
    const filter = event.target.value;
    setPage(1);
    getUsers(1, filter, reasondrop);
  };

  const handleChangeRoles = (event) => {
    const selectedRole = event.target.value;
    setReasondrop(selectedRole);
    list.length = 0;
    setPage(1);
    getUsers(1, statusfilter, selectedRole);
  };

  function handleChangeStatus(status) {
    setstatusLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', user.id);
    formdata.append('status', status.id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.update_user_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        if (status === 200 || status === 201) {
          refreshAdmin();
          getUsers(1, statusfilter, reasondrop);
          setalertSuccess({ visible: true, message: response.message });

          setTimeout(() => {
            handleCloseStatus();
          }, 2000);
        } else {
          setalert({ visible: true, message: 'Something went wrong' });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setstatusLoading(false);
      });
  }

  const historystyle = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const handleProductDetailsClose = () => {
    setProductDetailsOpen(false);
  };

  const refreshgetuserAddadmin = () => {
    setloading(true);
    list.length = 0;
    getUsers(1);
    setAddAdminModal(false);
  };

  const HistoryLogsTable = ({ user_id }) => {
    useEffect(() => {
      getUserHistory();
    }, []);

    const [historylogs, setHistoryLogs] = useState([]);
    const [loading, setloading] = useState(true);
    function getUserHistory() {
      setloading(true);
      const myHeaders = new Headers();

      const token = localStorage.getItem('token');
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      // Assuming the user_id needs to be part of the query string in the URL
      const url = `${api.get_login_logs}?user_id=${user_id}`;

      fetch(url, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error('Failed to retrieve user history');
          }
        })
        .then((result_) => {
          const result = JSON.parse(result_);
          setHistoryLogs(result?.data);
        })
        .catch((error) => {})
        .finally(() => {
          // setloading(false);
        });
    }
    return (
      <Box>
        <Typography variant="h5" textAlign={'center'}>
          Login History
        </Typography>

        <Card style={{ marginTop: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="body2" fontWeight={'bold'}>
                    Devices Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={'bold'}>
                    Date & Time
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography variant="body2 " fontWeight={'bold'}>
                    IP Information
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historylogs.length > 0 &&
                historylogs?.map((item, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell>
                        <Typography variant="body2" color="black">
                          {item?.device_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {dayjs(item?.updated_at).format('DD, MMMM , YYYY h:mm A') || 'N/A'}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="caption">{item?.device_ip || 'N/A'}</Typography>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              {loading && (
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <CircularProgress color="inherit" size={16} />
                  </TableCell>
                </TableRow>
              )}
              {/* IDHR */}
              {historylogs.length == 0 && !loading && (
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={''} />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Card>

        <Box
          style={{
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: 30
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={handleProductDetailsClose}
            size={'small'}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'deleted':
        return 'error';
      case 'blocked':
        return 'warning';
      case 'suspended':
        return 'warning';
      default:
        return 'primary';
    }
  };
  const currentStatus = user?.status;
  const updatedStatusOptions = statusList.filter((option) => {
    if (currentStatus === 'active') {
      return ['Block', 'Delete'].includes(option?.name);
    }
    if (currentStatus === 'blocked') {
      return ['Active', 'Delete'].includes(option?.name);
    }
    if (currentStatus === 'deleted') {
      return ['Active'].includes(option?.name);
    }
    return true;
  });

  return (
    <Page title={`Users | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* LOGIN HISTORY */}
        <Modal open={productDetailsOpen} onClose={handleProductDetailsClose} style={historystyle}>
          <Box sx={HistoryboxStyle} px={5} pt={2} pb={5}>
            <HistoryLogsTable user_id={userdetail?.id} />
          </Box>
        </Modal>

        {/* RESET USER MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openReset}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <ResetUserPassword user={user} handleClose={handleCloseModal} />
          </Box>
        </Modal>
        {/* CHANGE ROLE  */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <ChangeRoleModal user={user} handleClose={handleClose} refreshAdmin={refreshAdmin} />
          </Box>
        </Modal>
        {/* EDIT USER */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openUser}
          onClose={handleCloseUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <EditUserModal
              user={user}
              handleClose={handleCloseUserModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>
        {/* company profile modal */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={companymodal}
          onClose={handleCloseCompanyModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <CompanyProfile
              user={companyprofiledata}
              handleClose={handleCloseCompanyModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>
        {/* add company user modal */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={companyusermodal}
          onClose={handleCloseCompanyUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <UserCompanyProfileModal
              user={companyprofiledata}
              handleClose={handleCloseCompanyUserModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>
        {/* ADD ADMIN MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={AddAdminmodal}
          onClose={handleAddAdminCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <AddAdminModal
              fullWidth={true}
              user={roles}
              handleClose={handleAddAdminCloseModal}
              refreshAdmin={refreshgetuserAddadmin}
            />
          </Box>
        </Modal>

        {/* CHANGE STATUS */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openStatus}
          onClose={handleCloseStatus}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <Box p={1} py={3} flexDirection={'column'} display={'flex'} flex={1}>
              <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Change Status
              </Typography>

              <CardContent>
                {/* <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                  Current Status:{selectedStatus?.value}
                </Typography> */}

                <Typography
                  variant="h5"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: 20,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <span>Current Status:</span>
                  <Label
                    style={{ height: 30, width: 100 }}
                    variant="ghost"
                    color={getStatusColor(selectedStatus?.value)}
                  >
                    <div
                      style={{
                        // marginLeft: 8,
                        padding: '4px 10px',
                        borderRadius: 4,
                        fontWeight: 'bold',
                        textTransform: 'capitalize'
                      }}
                    >
                      {selectedStatus?.value || 'N/A'}
                    </div>
                  </Label>
                </Typography>
                <TextField
                  style={{ width: '100%' }}
                  select
                  value={statusss || selectedStatus}
                  // value={statusss ? statusss : selectedStatus}
                  label="Status"
                  onChange={handleChange}
                  className="width_full_status"
                >
                  {updatedStatusOptions.map((option) => (
                    <MenuItem key={option.id} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Box mt={2} />
                {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
                  <LoadingButton
                    disabled={!statusss}
                    style={{ marginTop: 20, marginRight: 10 }}
                    onClick={() => {
                      handleChangeStatus(statusss);
                    }}
                    variant="contained"
                    loading={statusLoading}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    style={{ marginTop: 20 }}
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      handleCloseStatus();
                    }}
                    size="large"
                  >
                    Close
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Users
          </Typography>
          {permission.includes('add') && (
            <Button
              onClick={() => {
                openAdminModal();
              }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="typcn:edit" />}
            >
              Add User
            </Button>
          )}
        </Stack>

        {alertSuccess && alertSuccess.visible && (
          <Alert style={{ marginBottom: 20 }} severity="success">
            {alertSuccess.message}
          </Alert>
        )}

        <Card
          sx={{
            bgcolor: '#151921',
            color: '#fff',
            borderRadius: 2,
            boxShadow: '0px 4px 20px rgba(0,0,0,0.4)'
          }}
        >
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={t('Agents.search')}
              onEnter={() => {
                setsearchLoading(true);
                list.length = 0;
                getUsers(1, statusfilter, reasondrop);
              }}
            />

            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getUsers(1, statusfilter, reasondrop);
              }}
              className="width_full_status"
            >
              {' '}
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={statusfilter}
              label={'Status'}
              onChange={handlefilterstatus}
              className="width_full_status"
              InputLabelProps={{ shrink: true }} // Correct prop for label shrink
            >
              {statusList
                .filter((option) => option.name !== 'Pending')
                .map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option}
                    style={{
                      textTransform: 'capitalize'
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
            </TextField>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={reasondrop}
              label="Sorting"
              onChange={handleChangeRoles}
              InputLabelProps={{ shrink: true }} // Correct prop for label shrink
            >
              {sortinglist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option?.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {list?.map((row) => {
                    const {
                      id,
                      staff_member,
                      username,
                      contact_no,
                      avatar,
                      email,
                      seen,
                      status,
                      role
                    } = row;
                    return (
                      <TableRow
                        hover
                        style={{
                          backgroundColor: seen == '0' && 'rgba(253,208,151,0.2)',
                          cursor: seen == '0' ? 'pointer' : 'default'
                        }}
                        key={id}
                        // tabIndex={-1}
                        role="checkbox"
                      >
                        <TableCell scope="row" padding="normal" style={{ width: 200 }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 150 }}
                          >
                            <Avatar alt={staff_member?.first_name} src={staff_member?.avatar} />
                            <Box
                              style={{ display: 'flex', flexDirection: 'column', maxWidth: 180 }}
                            >
                              <Typography
                                variant="subtitle2"
                                flexWrap={'wrap'}
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                  maxWidth: '100px'
                                }}
                              >
                                {!staff_member || staff_member?.first_name === 'undefined'
                                  ? 'N/A'
                                  : `${staff_member?.first_name} ${staff_member?.last_name}`}
                              </Typography>
                              <Typography
                                flexWrap={'wrap'}
                                style={{
                                  fontSize: 10,
                                  fontWeight: '600'
                                }}
                              >
                                {role?.role_name === 'undefined' ? 'N/A' : role?.role_name}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" style={{ maxWidth: 180 }}>
                          <Typography noWrap fontSize={12}>
                            {email || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell align="left" style={{ maxWidth: 150 }}>
                          <Typography noWrap fontSize={12}>
                            {staff_member?.contact_no ? staff_member?.contact_no : 'N/A'}
                          </Typography>
                        </TableCell>

                        <TableCell align="left" style={{ maxWidth: 150 }}>
                          <Label
                            style={{ height: 30, width: 100 }}
                            variant="ghost"
                            color={getStatusColor(status)}
                          >
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              {status}
                            </Typography>
                          </Label>
                        </TableCell>
                        <TableCell align="left">
                          <Box display="flex" flexDirection="row" m={0}>
                            {/* {permission.includes('edit') && (
                              <Tooltip title="User Company Profile">
                                <LoadingButton
                                  // disabled={status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  component={RouterLink}
                                  to="/dashboard/users/usercompanyprofile"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="solar:user-id-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )} */}

                            {permission.includes('edit') && (
                              <Tooltip title="Edit">
                                <LoadingButton
                                  disabled={status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => openUserModal(row)}
                                  // onClick={() => OpenCompanyModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="eva:edit-fill"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}

                            {permission.includes('change role') && (
                              <Tooltip title="Change Role">
                                <LoadingButton
                                  size="small"
                                  disabled={status?.toLowerCase() == 'deleted'}
                                  onClick={() => openModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    // icon="material-symbols:lock-clock-outline"
                                    icon="material-symbols:switch-account-outline-rounded"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('change password') && (
                              <Tooltip title="Change Password">
                                <LoadingButton
                                  disabled={status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => openResetModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="solar:password-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('change status') && (
                              <Tooltip title="Change Status">
                                <LoadingButton
                                  disabled={status?.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => {
                                    openModalStatus(row);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="tabler:status-change"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {/* EMPTY STATE */}
                {list.length === 0 && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {/* LOADER */}
              {loading && !searchLoading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </TableContainer>
          </Scrollbar>
        </Card>
        {/* PAGINATION */}
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
